
import { EventEmitter } from "events"

// should be combined with app/filter
const ee = new EventEmitter()

ee.on("filter:change", () => {
  ee.emit("filter:change:action")
})

ee.on("filter:loading", () => {
  ee.emit("filter:loading:action")
})

ee.on("filter:idle", () => {
  ee.emit("filter:idle:action")
})

ee.on("filter:update", () => {
  ee.emit("filter:update:action")
})

ee.on("filter:places:clear", () => {
  ee.emit("filter:places:clear:action")
})

ee.on("filter:map:places:clear", () => {
  ee.emit("filter:map:places:clear:action")
})

ee.on("filter:map:time_travel:clear", () => {
  ee.emit("filter:map:time_travel:clear:action")
})

export default ee
